export const CleanierLogo = ({ width, height, viewBox, fill, styles }) => {
  return (
    <svg
      width={width || '58'}
      height={height || '58'}
      viewBox={viewBox || '0 0 58 58'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <rect x="0.5" y="0.5" width="57" height="57" rx="28.5" fill="#E6F8F6" />
      <rect x="0.5" y="0.5" width="57" height="57" rx="28.5" stroke="#EBEEF3" />
      <path
        d="M28.7654 21.1594V13.5C20.6101 13.5 14 20.2532 14 28.5851H21.4971C21.7025 24.5789 24.8442 21.3692 28.7654 21.1594Z"
        fill="#00BEA1"
      />
      <path
        d="M21.4971 29.415H14C14 37.7469 20.6101 44.5001 28.7654 44.5001V36.8407C24.8442 36.6309 21.7025 33.4212 21.4971 29.415Z"
        fill="black"
      />
      <path
        d="M43.9631 25.1918C42.4553 18.4958 36.5897 13.5 29.5781 13.5V21.1594C32.2973 21.3048 34.6431 22.893 35.8918 25.1918H43.9631Z"
        fill="black"
      />
      <path
        d="M35.9805 32.6416C34.7551 35.0286 32.3627 36.6931 29.5781 36.8409V44.5003C36.6481 44.5003 42.5556 39.4211 44.0028 32.6416H35.9805Z"
        fill="black"
      />
    </svg>
  );
};
